import { useEffect } from "react";
import type * as React from "react";
import { Typography } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { trackWorkflowPageReached, type Workflow } from "analytics";
import StandaloneConfirmationPageLayout from "components/v3/layouts/StandaloneConfirmationPageLayout";
import {
  NAVIGATION_EMAIL,
  NAVIGATION_PHONE_DISPLAY
} from "components/v3/pages/CologuardLaunchPage/constants";
import { PATHS } from "constants/pathConstants";
import Translate from "translate/Translate";

const NavigatorRequestConfirmationPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation<{ analyticsWorkflow?: Workflow }>();
  const workflow =
    location.state?.analyticsWorkflow ?? "colon_cancer_screening";
  const continueToResources = workflow === "learning_resources";

  useEffect(() => {
    trackWorkflowPageReached({
      workflow,
      page: "navigator_confirmation",
      workflowStep: "started"
    });
  }, [workflow]);

  return (
    <StandaloneConfirmationPageLayout
      backLabel="Back"
      onBack={() => history.push(PATHS.LANDING_PAGE)}
      onPrimary={() =>
        history.push(
          continueToResources ? PATHS.HELP_CENTER_ROOT : PATHS.YOUR_NEXT_STEPS
        )
      }
      pageTitle="Thank you"
      primaryLabel={
        continueToResources ? "See your resources" : "Back to my next steps"
      }
      title="Thank you!"
    >
      <Typography component="p" sx={{ m: 0 }} variant="body_strong_black">
        <Translate text="A member of the Genomic Life navigation team will reach out soon. We look forward to talking with you soon." />
      </Typography>
      <Typography
        component="p"
        sx={{ fontStyle: "italic", m: 0 }}
        variant="body_black"
      >
        <Translate text="If you'd like to reach us before that time, leave us a message at" />{" "}
        {NAVIGATION_PHONE_DISPLAY} <Translate text="or email" />{" "}
        {NAVIGATION_EMAIL}.
      </Typography>
    </StandaloneConfirmationPageLayout>
  );
};

export default NavigatorRequestConfirmationPage;
